export default "__VITE_ASSET__CkqBX15z__"